import { useMutation } from "@tanstack/react-query";
import { buildReportAsync } from "../api";
import { useAddReport } from "./useReportHistory";
import { DEFAULT_PERSONA, getPersonaByValue } from "../utils/personas";

export function useBuildReportAsync() {
  const addReport = useAddReport();

  return useMutation({
    mutationFn: async ({ request, persona = DEFAULT_PERSONA.value }) => {
      const personaVersion = getPersonaByValue(persona).version;
      const r = await buildReportAsync({ user_request: request, persona: personaVersion });
      const taskId = r.task_id;
      const id = crypto.randomUUID();
      const reportData = {
        id,
        taskId,
        request,
        persona,
        plan: undefined,
        status: "requested",
      };

      addReport.mutate(reportData);

      return reportData;
    },
  });
}
